import { Address } from "../address/address";

export class IndividualRecordShort {
    individualId: string;
    firstName: string;
    lastName: string;
    middleName1?: string;
    middleName2?: string;
    fullNameStored: string;
    address?: Address;
    dob?: Date;
    din?: string;
    birthCity: string;
    birthCountry: string;

    constructor(init: Partial<IndividualRecordShort> = {}) {
        this.individualId = init?.individualId ?? '';
        this.firstName = init?.firstName ?? '';
        this.lastName = init?.lastName ?? '';
        this.middleName1 = init?.middleName1;
        this.middleName2 = init?.middleName2;
        this.fullNameStored = init?.fullNameStored ?? '';
        this.address = init?.address ? new Address(init.address) : undefined;
        this.dob = init?.dob ? new Date(init.dob) : undefined;
        this.din = init?.din;
        this.birthCity = init?.birthCity ?? '';
        this.birthCountry = init?.birthCountry ?? '';
    }

    getFullName(
      ): string {
        return [
          this.firstName,
          this.middleName1 ?? '',
          this.middleName2 ?? '',
          this.lastName
        ]
          .filter(part => part.trim().length > 0)
          .join(' ');
      }
}
